import Navbar from '../../components/feature/Navbar';
import SeoHead from '../../components/feature/SeoHead';
import TechnologyHero from './components/TechnologyHero';
import ResearchPartnership from './components/ResearchPartnership';
import SystemOverview from './components/SystemOverview';
import EnvironmentalBenefits from './components/EnvironmentalBenefits';
import TechnicalDetails from './components/TechnicalDetails';
import ResearchDevelopment from './components/ResearchDevelopment';
import TechnologyCTA from './components/TechnologyCTA';
import Footer from '../../components/feature/Footer';

const siteUrl = (import.meta.env.VITE_SITE_URL as string | undefined) ?? '';

const technologyJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '技術 | 株式会社C.GREEN | 筑波大学連携・循環型陸上養殖技術',
  url: `${siteUrl}/technology`,
  description:
    '筑波大学との共同研究から生まれた循環型陸上養殖技術をご紹介。独自の水処理システム・環境負荷低減・研究開発の最前線を解説します。',
  inLanguage: 'ja',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'ホーム', item: siteUrl },
      { '@type': 'ListItem', position: 2, name: '技術', item: `${siteUrl}/technology` },
    ],
  },
};

export default function TechnologyPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="技術 | 株式会社C.GREEN | 筑波大学連携・循環型陸上養殖技術"
        description="筑波大学との共同研究から生まれた循環型陸上養殖技術をご紹介。独自の水処理システム・環境負荷低減・研究開発の最前線を解説します。"
        keywords="循環型養殖技術,筑波大学,陸上養殖システム,水処理技術,環境技術,研究開発,C.GREEN技術"
        canonicalPath="/technology"
        jsonLd={technologyJsonLd}
      />
      <Navbar />
      <TechnologyHero />
      <ResearchPartnership />
      <SystemOverview />
      <EnvironmentalBenefits />
      <TechnicalDetails />
      <ResearchDevelopment />
      <TechnologyCTA />
      <Footer />
    </div>
  );
}
